module.exports = __webpack_public_path__ + "img/m1-menu-desktop.a872fb11.png";